import { useMemo } from 'react'

import { GroupOption } from '@/app/types'

import { type SegmentsQuery, useGetSegments } from './use-get-segments'

export const useGetSegmentOptions = (query: SegmentsQuery = {}) => {
  const res = useGetSegments(query)

  const options = useMemo<GroupOption[]>(() => {
    const segments = res.data?.groups || []

    return segments.map((segment) => ({
      numberOfContacts: segment.numberOfContacts,
      label: segment.name,
      recounting: segment.recounting,
      value: segment.id.toString(),
    }))
  }, [res.data?.groups])

  return {
    ...res,
    data: options,
  }
}
